var HsCartContentResponse = {
  addItem:function(result,$){
    //Adding to Slide Cart returns a response
  },
  updateItem:function(result,$){
    //Editing any product in the Slide Cart returns a response
  },
  deleteItem:function(result,$){
    //Removing any product from the Slide Cart returns a response
  },
  allItems:function(result,$){
    //It returns a response whenever an item is added, updated or deleted within the Slide Cart.
  }
}